import {ProjectTypes} from './project-types.enum';

export enum OnlyNetProjectTypes {
  GEO_BASIC = ProjectTypes.GEO_BASIC,
  GEO_BASIC_WIDGET = ProjectTypes.GEO_BASIC_WIDGET
}
